<script lang="ts">
  import Label from "@/lib/components/label/label.svelte";

  export let id: string | undefined;
  export let required = false;

  export let label = "";
  export let hint = "";
  export let description = "";
  export let error = "";
</script>

<div class="relative">
  {#if label}
    <Label for={id} class={hint ? "mb-2" : "mb-6"} {required}>
      {label}
    </Label>
  {/if}
  {#if hint}
    <p class="text-text-secondary mb-6">
      {hint}
    </p>
  {/if}
  <slot />
  {#if description}
    <p class="text-text-secondary mt-6">
      {description}
    </p>
  {/if}
  {#if error}
    <p class="color-error whitespace-nowrap mt-6">
      <!-- eslint-disable-next-line svelte/no-at-html-tags -->
      {@html error}
    </p>
  {/if}
</div>
